import {
  ADD_MESSAGE,
  SET_TYPING,
  SET_ERROR,
  CLEAR_MESSAGES,
  LOAD_HISTORY
} from '../actions/ChatAction';

const INITIAL_STATE = {
  messages: [],
  isTyping: false,
  error: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_MESSAGE:
      return { ...state, messages: [...state.messages, action.payload], error: null };
    case SET_TYPING:
      return { ...state, isTyping: action.payload };
    case SET_ERROR:
      return { ...state, error: action.payload, isTyping: false };
    case CLEAR_MESSAGES:
      return { ...state, messages: [], error: null };
    case LOAD_HISTORY:
      return { ...state, messages: action.payload || [] };
    default:
      return state;
  }
};